import { Bounds, Center, OrbitControls } from '@react-three/drei'
import { Canvas, useLoader } from '@react-three/fiber'
import { STLLoader } from 'three-stdlib'
import { Suspense, useCallback, useEffect } from 'react'
import useFullPageLoader from 'Hooks/useFullPageLoader'

function STLModel({ fileUrl, onLoaded }) {
  const geometry = useLoader(STLLoader, fileUrl)

  useEffect(() => {
    onLoaded()
  }, [geometry, onLoaded])

  return (
    <mesh geometry={geometry} castShadow receiveShadow>
      <meshStandardMaterial color="#b8b8b8" metalness={0.15} roughness={0.55} />
    </mesh>
  )
}

const STLFileViewer = ({ fileUrl }) => {
  const [loader, setLoader, resetLoader] = useFullPageLoader()
  const handleLoaded = useCallback(() => resetLoader(), [resetLoader])

  useEffect(() => {
    setLoader()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Canvas
        shadows
        camera={{ position: [0, 0, 5], fov: 45 }}
        style={{ width: '100%', height: '100%', cursor: 'pointer' }}
      >
        <ambientLight intensity={0.7} />
        <directionalLight castShadow position={[5, 10, 7]} intensity={1.1} />
        <Suspense fallback={null}>
          <Bounds fit clip observe margin={1.2}>
            <Center>
              <STLModel fileUrl={fileUrl} onLoaded={handleLoaded} />
            </Center>
          </Bounds>
        </Suspense>
        <OrbitControls makeDefault />
      </Canvas>
      {loader}
    </>
  )
}

export default STLFileViewer
